import React, {Component} from 'react';
import { RTLTable,RTLCol,RTLButton } from '../RTLKit';
import {Divider, Row, Form} from 'antd';
import {Field, reduxForm} from "redux-form";
import SelectField from "../formFields/SelectField";
import {CSVLink} from "react-csv";

const columns = [
    {
        title: 'ردیف',
        dataIndex: 'key',
        label: 'ردیف',
        key: 'key',
        width:'10%'
    },
    {
        title: 'نام',
        dataIndex: 'name',
        label: 'نام',
        key: 'name',
    },
    {
        title: 'نام خانوادگی',
        dataIndex: 'family',
        label: 'نام خانوادگی',
        key: 'family',
    },
    {
        title: 'استان',
        dataIndex: 'state',
        label: 'استان',
        key: 'state',
    },
    {
        title: 'امتیاز',
        dataIndex: 'rank',
        label: 'امتیاز',
        key: 'rank',
    },
];


class Pos extends Component {

    constructor(props) {
        super(props);
        this.state = {
            role:'',
            searchBoxHidden:true, //hidden=true
            loading:true,
            pageSize:10,
            current: (this.props.list ? this.props.list.pageNumber : 1)
        }
    }

    componentWillMount() {
        this.props.getList()
        this.props.getUserList({size:10});
        // this.props.getUserList({size:10000});
    }

    __getUserList() {
        let userList = this.props.userList;
        let dataSource = [];

        if (userList && userList.lists) {

            for (let i = 0; i < userList.lists.length; i++) {

                if(userList.lists[i].role == "TECHNICIAN")
                    dataSource.push(
                        {label: userList.lists[i].name+' '+userList.lists[i].family, value: userList.lists[i]._id, key: i}
                    );

            }

        }
        return dataSource;
    }

    /*--- pagination ---*/
    handlePageChange(pageNumber) {
        this.setState({current: pageNumber});
        this.props.getList({page:pageNumber});
    }

    /*--- fix user list for show in table ---*/
    __fixListForShowInTable() {
        var list = this.props.list;
        var dataSource = [];

        if(list) {
            for (let i = 0; i < list.length; i++) {

                dataSource.push({
                    key    : i+1,
                    name   : list[i].name,
                    family : list[i].family,
                    state  : list[i].branch_operator_state && list[i].branch_operator_state.title ? list[i].branch_operator_state.title : '',
                    rank   : list[i].rank,
                });
            }
        }
        return dataSource;
    }

    __toggleSearchBox(){
        this.setState({
            searchBoxHidden : !this.state.searchBoxHidden
        })
    }

    __onChangeCounter(value) {
        this.setState({
            pageSize:value
        })
    }

    /*-- search form ---*/
    onFormSubmit(value) {
        this.props.handleSubmit(value);
    }

    __clearFilter() {
        this.props.reset();
        this.props.getList()
    }

    __goBack(){
        this.props.history.goBack()
    }

    render() {
        var _self = this;
        const {pageSize,searchBoxHidden } = this.state;
        const { list } = this.props;
        var data = this.__fixListForShowInTable()

        return (
            <div>
                <Row type="flex">
                    <RTLCol xs={24} md={20}>
                        <Divider orientation="left">میانگین امتیازات تکنسین</Divider>
                    </RTLCol>
                    <RTLCol xs={24} md={4} >
                        <RTLButton type="primary" className="userListBtn" shape="round" icon="search" onClick={this.__toggleSearchBox.bind(this)} ></RTLButton>
                        {data.length > 0 ?
                            <RTLButton type="primary" className="userListBtn" shape="round" >
                                <CSVLink
                                    data={data}
                                    headers={columns}
                                    className='export-link'
                                    filename={"report_technician_rate.csv"}
                                    target="_blank"
                                >
                                    خروجی اکسل
                                </CSVLink>
                            </RTLButton>
                            : null}
                    </RTLCol>
                </Row>
                <Row>
                    <Form name="search" onSubmit={this.onFormSubmit.bind(this)} className="login-form">
                        <Row gutter={4} type="flex" justify="start" align="top" hidden={searchBoxHidden} >
                            <RTLCol sm={12} md={5}>
                                <Field
                                    name="technician_by"
                                    component={SelectField}
                                    placeholder="تکنسین"
                                    list={this.__getUserList()}
                                />
                            </RTLCol>
                            <RTLCol sm={24} md={2}>
                                <RTLButton className="left" type="default" shape="round" onClick={this.__clearFilter.bind(this)}>
                                    بروزرسانی
                                </RTLButton>
                            </RTLCol>
                            <RTLCol sm={24} md={2}>
                                <RTLButton loading={this.props.common.isProgressing} className="left" type="primary" shape="round" htmlType="submit">
                                    جستجو
                                </RTLButton>
                            </RTLCol>
                        </Row>
                    </Form>
                </Row>
                <Row>
                    <RTLTable rowClassName={(record, index) => (index+1)%2 == 0 ? 'even' : 'odd' } rowClassName={(record, index) => (index+1)%2 == 0 ? 'even' : 'odd' } pagination={false} columns={columns} dataSource={this.__fixListForShowInTable()} size="small" />
                </Row>
                <RTLButton onClick={this.__goBack.bind(this)} className="backBtn2" type="default" >
                    بازگشت
                </RTLButton>
            </div>
        );
    }
}

export default Pos = reduxForm({
    form: 'list'
})(Pos)
